import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';

import { ListData } from './list-data';
import { ObjectProperties } from './object-properties';
import { ServiceLayoutColumn } from './service-layout-column';

const metaData = {
    IsSearchReturnedResult: DataType.BOOL,
    Loading: DataType.BOOL,
    LinkedRecords: DataType.OBJECT,
};

KnownPropertyTypes.setFor(metaData);

export abstract class AbstractServiceRecord implements IGenericAccessor {
    public IsCollectionDiff?: boolean;
    public ChatData: Array<any>;
    public DefaultLayout?: {
        DefaultLayout: Array<ServiceLayoutColumn>;
        DefaultLayoutType: number;
    };
    public IsSearchReturnedResult?: boolean;
    public ListData: ListData;
    public Loading?: boolean;
    // Array from service
    public ObjectProperties: Array<{ FieldName: string; FieldValue: any }>;
    public ObjectPropertiesCollection: ObjectProperties;
    public LinkedRecords: Array<any> = [];

    private getMyMetaData(): { [id: string]: number } {
        const objectKeys = Object.keys(this);
        const ret = {};
        for (const prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getMetaData(): { [id: string]: number } {
        const ret = this.getMyMetaData();
        const listMetaData = this.ListData.getMetaData();
        const objectPropertiesMetaData = this.ObjectPropertiesCollection.getMetaData();

        // merge
        for (const p in listMetaData) {
            ret[p] = listMetaData[p];
        }

        for (const p in objectPropertiesMetaData) {
            if (!ret[p]) ret[p] = objectPropertiesMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getMyMetaData()[field]) {
            return this[field];
        }
        if (this.ListData.getMetaData()[field]) {
            return this.ListData.getRawValue(field);
        }
        return this.ObjectPropertiesCollection.getRawValue(field);
    }

    public instantiateChildren() {
        this.ListData = Object.assign(new ListData(), this.ListData);
        this.ObjectPropertiesCollection = new ObjectProperties(this.ObjectProperties);
    }
}
